import React from 'react';
import {
  Box,
  HStack,
  Input,
  Select,
  Checkbox,
  Icon,
  useColorModeValue,
  Button,
} from '@chakra-ui/react';
import { FaSearch, FaTimes } from 'react-icons/fa';

const CATEGORIE = [
  { value: '', label: 'Tutte le categorie' },
  { value: 'Giochi & tempo libero', label: 'Giochi & tempo libero' },
  { value: 'Libri, fumetti & manuali', label: 'Libri, fumetti & manuali' },
  { value: 'Abbigliamento & accessori', label: 'Abbigliamento & accessori' },
  { value: 'Casa & arredamento', label: 'Casa & arredamento' },
  {
    value: 'Elettrodomestici & elettronica',
    label: 'Elettrodomestici & elettronica',
  },
  { value: 'Attrezzi & fai-da-te', label: 'Attrezzi & fai-da-te' },
  { value: 'Sport & mobilità', label: 'Sport & mobilità' },
  { value: 'Bambini & infanzia', label: 'Bambini & infanzia' },
  { value: 'Varie', label: 'Varie' },
];

const STATI = [
  { value: 'disponibile', label: 'Disponibile' },
  { value: 'prenotato', label: 'Prenotato' },
  { value: 'venduto', label: 'Venduto' },
  { value: 'terminato', label: 'Terminato' },
];

export default function BazarFilterBar({
  filters,
  onFiltersChange,
  isAuthenticated = false,
}) {
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  const handleSearchChange = (e) => {
    onFiltersChange({ ...filters, search: e.target.value });
  };

  const handleCategoriaChange = (e) => {
    onFiltersChange({ ...filters, categoria: e.target.value || null });
  };

  const handleStatoChange = (statoValue, isChecked) => {
    const currentStati = filters.stato || ['disponibile', 'prenotato'];
    let newStati;

    if (isChecked) {
      // Aggiungi lo stato se non è già presente
      newStati = currentStati.includes(statoValue)
        ? currentStati
        : [...currentStati, statoValue];
    } else {
      // Rimuovi lo stato
      newStati = currentStati.filter((s) => s !== statoValue);
      // Se rimangono vuoti, usa default
      if (newStati.length === 0) {
        newStati = ['disponibile', 'prenotato'];
      }
    }

    onFiltersChange({ ...filters, stato: newStati });
  };

  const handleSoloMieiChange = (e) => {
    onFiltersChange({ ...filters, soloMiei: e.target.checked });
  };

  const handleClearFilters = () => {
    onFiltersChange({
      search: '',
      categoria: null,
      condizione: null,
      stato: ['disponibile', 'prenotato'],
      prezzoMin: null,
      prezzoMax: null,
      negoziabile: null,
      soloMiei: false,
    });
  };

  // Verifica se ci sono filtri attivi
  const hasActiveFilters =
    (filters.search && filters.search.trim() !== '') ||
    filters.categoria ||
    filters.condizione ||
    filters.prezzoMin ||
    filters.prezzoMax ||
    filters.negoziabile !== null ||
    filters.soloMiei ||
    (filters.stato &&
      (filters.stato.length !== 2 ||
        !filters.stato.includes('disponibile') ||
        !filters.stato.includes('prenotato')));

  return (
    <Box
      bg={cardBg}
      borderRadius="lg"
      border="1px solid"
      borderColor={borderColor}
      p={3}
      mb={6}
    >
      <HStack spacing={3} flexWrap="wrap" align="center">
        {/* Ricerca testuale */}
        <Box flex="1" minW="200px">
          <HStack spacing={2}>
            <Icon
              as={FaSearch}
              color="gray.400"
              display={{ base: 'none', md: 'block' }}
            />
            <Input
              placeholder="Cerca..."
              value={filters.search || ''}
              onChange={handleSearchChange}
              size="md"
              data-testid="bazar-filter-search"
            />
          </HStack>
        </Box>

        {/* Categoria */}
        <Box minW="180px">
          <Select
            value={filters.categoria || ''}
            onChange={handleCategoriaChange}
            size="md"
            placeholder="Tutte le categorie"
          >
            {CATEGORIE.filter((cat) => cat.value !== '').map((cat) => (
              <option key={cat.value} value={cat.value}>
                {cat.label}
              </option>
            ))}
          </Select>
        </Box>

        {/* Filtri Stato */}
        <HStack spacing={2} flexWrap="wrap">
          {STATI.map((stato) => {
            const currentStati = filters.stato || ['disponibile', 'prenotato'];
            const isChecked = currentStati.includes(stato.value);
            return (
              <Checkbox
                key={stato.value}
                isChecked={isChecked}
                onChange={(e) =>
                  handleStatoChange(stato.value, e.target.checked)
                }
                size="sm"
              >
                {stato.label}
              </Checkbox>
            );
          })}
          {/* Filtro I miei oggetti */}
          {isAuthenticated && (
            <Checkbox
              isChecked={filters.soloMiei || false}
              onChange={handleSoloMieiChange}
              size="sm"
            >
              I miei oggetti
            </Checkbox>
          )}
        </HStack>

        {/* Pulsante Rimuovi filtri */}
        {hasActiveFilters && (
          <Button
            leftIcon={<FaTimes />}
            size="sm"
            variant="outline"
            colorScheme="gray"
            onClick={handleClearFilters}
          >
            Rimuovi filtri
          </Button>
        )}
      </HStack>
    </Box>
  );
}
